import i18n from '@/vendors/i18n'
import Page from '@/classes/pages/Page'
import Pages from '@/classes/pages/Pages'
import Campaigns from '@/classes/campaigns/Campaigns'
import { get as _get } from 'lodash'

export default class Client {
  constructor ({ id = null, name = null, default_currency = null, active_currencies = [], active_languages = [], allowed_features = {}, domain_names = {}, emails = [], favicon = null, frontend_integrations = {}, integrations = {}, is_maintenance = false, layouts, main_layout = {}, pages, campaigns, logo = {}, logo_email = {}, platform = {}, style = {} } = {}) {
    this.id = id
    this.name = name
    this.default_currency = default_currency
    this.active_currencies = active_currencies
    this.active_languages = active_languages
    this.allowed_features = allowed_features
    this.domain_names = domain_names
    this.emails = emails
    this.favicon = favicon
    this.frontend_integrations = frontend_integrations
    this.integrations = integrations
    this.is_maintenance = is_maintenance
    this.layouts = new Pages(layouts)
    this.main_layout = new Page(main_layout)
    this.pages = new Pages(pages)
    this.campaigns = new Campaigns(campaigns)
    this.logo = logo
    this.logo_email = logo_email
    this.platform = platform
    this.style = style
  }

  get tamaro () {
    return _get(this.integrations, 'tamaro', {})
  }

  get social_networks () {
    return _get(this.platform, 'social_networks', []).filter(sn => i18n.translate(sn.url))
  }

  get is_multi_currency () {
    return this.active_currencies.length > 1
  }

  get has_consent_management_platform () {
    return !!this.frontend_integrations.consent_management_platform
  }

  get gtm_container_id () {
    return this.frontend_integrations.gtm_containerid
  }

  get to_mixpanel () {
    return {
      'Client Id': this.id,
      'Client Name': this.name
    }
  }

  get to_sentry () {
    return {
      id: this.id,
      name: this.name,
      allowed_features: this.allowed_features,
      active_languages: this.active_languages,
      active_currencies: this.active_currencies
    }
  }
}
